import { all, call, put, select, takeLatest } from "redux-saga/effects";
import api from "../../utils/api";
import {
  fetchLocationInsightsFailure,
  fetchLocationInsightsSuccess,
} from "./actions";
import { FETCH_LOCATION_INSIGHTS } from "./constants";

const getToken = (state) => state?.AuthReducer?.token;

const getErrorMessage = (error, fallback) => {
  if (typeof error === "string") return error;
  return error?.error || error?.message || fallback;
};

export function* fetchLocationInsightsSaga({ payload }) {
  const token = yield select(getToken);

  try {
    const response = yield call(api(token).get, "/api/hearth/insights", {
      params: payload,
    });
    yield put(fetchLocationInsightsSuccess(response?.data || null));
  } catch (error) {
    yield put(
      fetchLocationInsightsFailure(
        getErrorMessage(error, "Could not load insights for this care home."),
      ),
    );
  }
}

export default function* LocationInsightsSaga() {
  yield all([takeLatest(FETCH_LOCATION_INSIGHTS, fetchLocationInsightsSaga)]);
}
